import React, { useState, useEffect } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { FaBuilding } from "react-icons/fa";
import Layout from "../../components/Layout";
import { apiCRMv3 } from "../../services/api";
import * as moment from "moment-timezone";

const UserCrmData = (props) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userId = params.get("userId");
    const userName = params.get("userName")
    const [clientList, setClientList] = useState([]);
    const [clientListSended, setClientListSended] = useState([]);
    const [birthday, setBirthday] = useState([]);
    const [birthdayToday, setBirthdayToday] = useState([]);
    const [birthdaySended, setBirthdaySended] = useState([]);
    const [easyBuy, setEasyBuy] = useState([]);
    const [easyBuySended, setEasyBuySended] = useState([]);
    const [eligibleWarranty, setEligibleWarranty] = useState([]);
    const [eligibleWarrantySended, setEligibleWarrantySended] = useState([]);
    const [lostClick, setLostClick] = useState([]);
    const [lostClickSended, setLostClickSended] = useState([]);
    const [rightTime, setRightTime] = useState([]);
    const [rightTime90a120, setRightTime90a120] = useState([]);
    const [rightTime121a150, setRightTime121a150] = useState([]);
    const [rightTime151a180, setRightTime151a180] = useState([]);
    const [rightTime181a360, setRightTime181a360] = useState([]);
    const [rightTime361, setRightTime361] = useState([]);
    const [rightTimeSended, setRightTimeSended] = useState([]);
    const [smartList, setSmartList] = useState([]);
    const [smartListSended, setSmartListSended] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const start = moment.tz("America/Sao_Paulo").startOf("month").format("YYYY-MM-DD");
        const end = moment.tz("America/Sao_Paulo").endOf("month").format("YYYY-MM-DD");
        loadList(start, end, userId);
    }, []);

    async function loadList(start, end, userId) {
        setLoaded(false);
        const response = await apiCRMv3.get(`/crm-analysis/data-by-user`, {
                params: { userId, start, end }
            });

        const data = response.data.data;
        setClientList(data.clientList);
        setClientListSended(data.clientListSended);
        setBirthday(data.birthday);
        setBirthdayToday(data.birthdayToday);
        setBirthdaySended(data.birthdaySended);
        setEasyBuy(data.easyBuy);
        setEasyBuySended(data.easyBuySended);
        setEligibleWarranty(data.eligibleWarranty);
        setEligibleWarrantySended(data.eligibleWarrantySended);
        setLostClick(data.lostClick);
        setLostClickSended(data.lostClickSended);
        setRightTime(data.rightTime)
        setRightTime90a120(data.rightTime90a120);
        setRightTime121a150(data.rightTime121a150);
        setRightTime151a180(data.rightTime151a180);
        setRightTime181a360(data.rightTime181a360);
        setRightTime361(data.rightTime361)
        setRightTimeSended(data.rightTimeSended);
        setSmartList(data.smartList);
        setSmartListSended(data.smartListSended);
        setLoaded(true);
    }

    const cards = [
        { title: "Funil 2.0", sended: clientListSended, available: clientList },
        { title: "Aniversariantes", sended: birthdaySended, available: birthday, extra: `Aniversariando Hoje: ${birthdayToday}` },
        { title: "Pagando Últ. Parcelas", sended: easyBuySended, available: easyBuy },
        { title: "Garantias Elegíveis", sended: eligibleWarrantySended, available: eligibleWarranty },
        { title: "Remarketing", sended: lostClickSended, available: lostClick },
        { title: "Inativos", sended: rightTimeSended, available: rightTime, rightTime90a120: `Inativos 90 a 120: ${rightTime90a120}`, 
            rightTime121a150: `Inativos 121 a 150: ${rightTime121a150}`, rightTime151a180: `Inativos 151 a 180: ${rightTime151a180}`, rightTime181a360: `Inativos 181 a 360: ${rightTime181a360}`,
            rightTime361: `Inativos 361 mais: ${rightTime361}`,
        },
        { title: "Funil 3.0", sended: smartListSended, available: smartList },
    ];

    return (
        <Layout menuActive="registers" pageTitle="Dados Vendedor">
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Dados Vendedor {userName}</div>
                        </div>

                        <div className={`card-body ${loaded ? "" : "__loading"}`}>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: "30px"
                            }}>
                                {/* Coluna dos Cards */}
                                <div className="col-xs-4">
                                    <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "20px" }}>
                                        {cards.map((card, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    background: "#fff",
                                                    borderRadius: "12px",
                                                    padding: "20px",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                                    transition: "transform 0.2s",
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                                                onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                    <FaBuilding size={20} color="#095077" style={{ marginRight: "10px" }} />
                                                    <h3 style={{ margin: 0 }}>{card.title}</h3>
                                                </div>
                                                <h4>Enviados: {card.sended}</h4>
                                                <h4>Disponiveis: {card.available}</h4>
                                                {card.extra && <h4>{card.extra}</h4>}
                                                {card.rightTime90a120 && <h4>{card.rightTime90a120}</h4>}
                                                {card.rightTime121a150 && <h4>{card.rightTime121a150}</h4>}
                                                {card.rightTime151a180 && <h4>{card.rightTime151a180}</h4>}
                                                {card.rightTime181a360 && <h4>{card.rightTime181a360}</h4>}
                                                {card.rightTime361 && <h4>{card.rightTime361}</h4>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(UserCrmData);